export function resellers() {
	let root = document.getElementsByClassName('resellers');

	if(root[0]) {
		let parent = document.getElementById('markers');
		let pins = parent.getElementsByTagName('g');
		let logoRoot = document.getElementById('placeholder')
		let logo = logoRoot.getElementsByTagName('image');

		for (let pin of pins)
		{
			let id = pin.id.replace(/[^a-zA-Z]/g,"");

			if(pin.id)
			{
				if(pin.id === 'yaskawa')
				{
					pin.classList.add('active');
				}
				pin.addEventListener('click', function()
				{
					for(let pin of pins)
					{
						pin.classList.remove('active')
					}

					pin.classList.add('active');
					logo[0].setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', window.location.origin + '/wp-content/themes/wsr/resource/image/resellers/logos/' + id + '.png');
				}, false);
			}
		}
	}
}